export enum SwitchingStatus {
  SWITCH = 'SWITCH',

  END_OF_SUPPLIER = 'END_OF_SUPPLIER',

  MOVE_IN = 'MOVE_IN',

  MOVE_OUT = 'MOVE_OUT',

  MOVED_OUT = 'MOVED_OUT',
}
